const DICT = `/candidates/settings/`;

const API = {
	DICT
};

export default API;
